import { JSX } from "react";
import { Row, Row1, TextBody } from "../lib";

type Props = {
  name: string;
  value: string | number | JSX.Element;
};

export function Detail({ name, value }: Props) {
  const valueEl =
    typeof value === "string" || typeof value === "number" ? (
      <TextBody em>{value}</TextBody>
    ) : (
      value
    );

  return (
    <Row.LRT mb="1">
      <TextBody>{name}</TextBody>
      <Row1.R>{valueEl}</Row1.R>
    </Row.LRT>
  );
}
